<div class="from-top">
    <app-ribbon [ribbon]="ribbon" *ngFor="let ribbon of ribbons"></app-ribbon>

    <!-- Ad Banner -->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6 mx-auto" id="CATALOG_BANNER"></div>
        </div>
    </div>
</div>